import { addDoc, collection, deleteDoc, doc, getDocs, query, Timestamp, where } from "firebase/firestore"
import { db } from "../firebase";
import Transaction from "../models/Transaction";

const getTransactions = async (plan: string, type?: "income" | "expense"): Promise<Transaction[]> => {
    const transactionsRef = collection(db, "transaction");   
    const q = type ? query(transactionsRef, where("type", "==", type), where("plan_id", "==", plan)) :
        query(transactionsRef, where("plan_id", "==", plan));
    const transactionSnapshot = await getDocs(q);
    return transactionSnapshot.docs.map(doc => {
        const transaction = doc.data() as Transaction;
        transaction.uid = doc.id;
        return transaction;
    });
}

const createTransaction = async (description: string, category: string, type: "income" | "expense", plan: string, amount: number, date: Date, user_id: string, recurrance: Transaction["recurrance"]): Promise<string> => {
    const transaction: Partial<Transaction> = {
        plan_id: plan,
        amount,
        type,
        description,
        category,
        date: Timestamp.fromDate(date),
        user_id,
        recurrance,
        createdAt: Timestamp.fromDate(new Date()),
        updatedAt: Timestamp.fromDate(new Date())
    }
    const transactionsRef = collection(db, "transaction");   
    const docRef = await addDoc(transactionsRef, transaction);
    return docRef.id;
}

const deleteTransaction = async (uid: string) => {
    const transactionRef = doc(db, "transaction", uid);
    await deleteDoc(transactionRef);
}

const deleteCategoryTransactions = async (plan_id: string, category: string) => {
    const queryRef = collection(db, "transaction");
    const q = query(queryRef, where("plan_id", "==", plan_id), where("category", "==", category));
    const transactionSnapshot = await getDocs(q);
    transactionSnapshot.forEach(async (document) => {
        const transactionRef = doc(db, "transaction", document.id);
        await deleteDoc(transactionRef);
    });
}

const TransactionController = {
    getTransactions,
    createTransaction,
    deleteTransaction,
    deleteCategoryTransactions
}
export default TransactionController;